import React from 'react';

import Edit from './controls/edit';
import Readonly from './controls/readonly';

class BMIField extends React.Component {
  render() {
    let res = this.props.value || {};

    let value = typeof res === 'string' ? JSON.parse(res) : res;

    const { height, weight } = value;

    if (this.props.readOnly) {
      return <Readonly height={height} weight={weight} />;
    }

    const { errored, warning, onChange } = this.props;

    return (
      <Edit
        errored={errored}
        height={height}
        warning={warning}
        weight={weight}
        onChange={onChange}
      />
    );
  }
}

export { BMIField };
export default BMIField;
